// Waiting-area displays (docs/plans/phase1-triage.md §3.4, §6.2; ADR 0013).
import {
  displayBoardSchema,
  pairedQueueDisplaySchema,
  queueDisplaySchema,
  type queueDisplayInputSchema,
} from '@wodi/shared';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';

import { api } from './client.ts';

export const queueDisplaysQuery = queryOptions({
  queryKey: ['admin', 'queue-displays'],
  queryFn: () => api('GET', '/admin/queue-displays', { schema: z.array(queueDisplaySchema) }),
});

export function pairQueueDisplay(body: z.input<typeof queueDisplayInputSchema>) {
  return api('POST', '/admin/queue-displays', { body, schema: pairedQueueDisplaySchema });
}

export function revokeQueueDisplay(id: string) {
  return api('POST', `/admin/queue-displays/${id}/revoke`, { schema: queueDisplaySchema });
}

/** Run on the display itself: exchanges the one-time token for its cookie. */
export function claimDisplay(token: string) {
  return api('POST', '/display/pair', { body: { token } });
}

export function fetchDisplayBoard() {
  return api('GET', '/display/board', { schema: displayBoardSchema });
}

/** The pairing link. The token is in the fragment, which is never sent to a server. */
export function pairingLink(origin: string, token: string): string {
  return `${origin}/display#token=${encodeURIComponent(token)}`;
}
